/**
 *  @class
 *  @function StickyNav
 */
if (!customElements.get('sticky-nav')) {
    class StickyNav extends HTMLElement {
      constructor() {
        super();
        this.container = document.querySelector('.sticky-nav');
        let element = document.getElementById("header");
        let height = element.offsetHeight;
        let topHeight = element.offsetTop;
        let customNavEl = document.querySelector('.customNav');
        let customNavHeight = document.querySelector('.customNav').offsetHeight;
        let isHideNav=document.querySelector('sticky-nav').getAttribute('data-hideNav')
        if($("#epb_container")){
          setTimeout(function(){
            height= element.offsetHeight + $("#epb_container").height()+'px';
            document.querySelector('.section-sticky-nav').style.top = element.offsetHeight+'px';
          },1000)
        }
        document.querySelector('.section-sticky-nav').style.top = height + 'px';
        this.links = document.querySelectorAll('.sticky-nav-link');

        function getAllDataTargets() {
          return Array.from(document.querySelectorAll('.sticky-nav-link'))
            .map(el => (document.getElementById(el.getAttribute('data-target'))));
        }
        const dataTargets = getAllDataTargets();
        console.log("dataTargets",dataTargets);
        const options = {
          root: null, 
          rootMargin: '0px', 
          threshold: 0.1 
        };
        const observer = new IntersectionObserver((entries) => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
          
               this.links.forEach((link) => {
                link.querySelector('a').classList.remove('active');
              })
              document.querySelector(`[data-target="${entry.target.id}"]`).querySelector('a').classList.add('active');
            } else {
                          }
          });
        }, options);
        dataTargets.forEach(div => {
          observer.observe(div);
        });
        this.setupEventListeners();
          // const stickyElement = document.querySelector('.section-sticky-nav');
          // let isStickyAtTop = false;
          // window.addEventListener('scroll', () => {
          //   const rect = stickyElement.getBoundingClientRect();
          //   if (rect.top <= height && !isStickyAtTop) {
          //     isStickyAtTop = true;
          //     customNavEl.style.display = 'none';
          //   } else if (rect.top > height && isStickyAtTop) {
          //     isStickyAtTop = false;
          //     customNavEl.style.display = 'block';
          //   }
          // });
          // console.log("==sticky-nav===")
      }
      setupEventListeners() {
        this.links.forEach((link) => {
          link.addEventListener('click', (event) => {
            this.clickNav(event)
          });
        });
      }
      clickNav(event){
        this.links.forEach((link) => {
          link.querySelector('a').classList.remove('active');
        })
        event.target.classList.add('active');
      }
    }
    customElements.define('sticky-nav', StickyNav);
  }